import React from 'react';
import { classes } from 'typestyle';
import styles from './styles';

interface TabProps {
  className?: string;
  heading: string;
}

class Tab extends React.Component<TabProps> {
  render() {
    const { children } = this.props;

    return <div className={styles.tabWrapper}>{children}</div>;
  }
}

interface TabsProps {
  className?: string;
}

export default class Tabs extends React.Component<TabsProps> {
  static Tab = Tab;

  state = {
    selected: 0,
  };

  selectTab(index: number) {
    this.setState({
      selected: index,
    });
  }

  render() {
    const { children } = this.props;
    const { selected } = this.state;

    const childrenArray = Array.isArray(children) ? children : [children];
    const tabs: Tab[] = childrenArray.filter(
      (el) => typeof el === 'object' && 'type' in el && el.type === Tab,
    ) as Tab[];
    const headings = tabs.map((tab) => tab.props.heading);
    const tab = tabs[selected];

    return (
      <div className={styles.wrapper}>
        <ul className={styles.list}>
          {headings.map((heading, index) => (
            <li
              className={classes(styles.listItem, selected === index ? 'selected' : false)}
              onClick={() => this.selectTab(index)}
              key={index}
            >
              <span className={styles.listItemText}>{heading}</span>
            </li>
          ))}
        </ul>
        {tab}
      </div>
    );
  }
}
